import { Autocomplete } from "@react-google-maps/api";
import React from "react";

function BillingForm({
  form,
  handleChange,
  handlePlaceChanged,
  showBilling,
  setShowBilling,
  getInputClass,
  autocompleteRef,
}) {
  return (
    <div>
      <div className="flex items-center mb-4">
        <input
          type="checkbox"
          id="invoiceCheckbox"
          className="mr-2"
          checked={showBilling}
          onChange={() => setShowBilling(!showBilling)}
        />
        <label htmlFor="invoiceCheckbox" className="text-lg">
          I want to receive an invoice
        </label>
      </div>

      {showBilling && (
        <>
          <h3 className="text-xl font-medium pt-3 pb-3">Billing Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full">
            <input
              className={`${getInputClass("companyName")} col-span-2`}
              type="text"
              name="companyName"
              placeholder="Company Name*"
              value={form.companyName ?? ""}
              onChange={handleChange}
            />
            <Autocomplete
              onLoad={(ref) => (autocompleteRef.current = ref)}
              onPlaceChanged={handlePlaceChanged}
              className="col-span-2"
            >
              <input
                className={`${getInputClass("address1")} w-full col-span-2`}
                type="text"
                name="address1"
                placeholder="Address*"
                value={form.address1 ?? ""}
                onChange={handleChange}
              />
            </Autocomplete>
            <input
              className={`${getInputClass(
                "postcode"
              )} col-span-2 md:col-span-1`}
              type="text"
              name="postcode"
              placeholder="Postal Code*"
              value={form.postcode ?? ""}
              onChange={handleChange}
            />
            <input
              className={`${getInputClass("city")} col-span-2 md:col-span-1`}
              type="text"
              name="city"
              placeholder="City*"
              value={form.city ?? ""}
              onChange={handleChange}
            />
            <input
              className={`${getInputClass("country")} col-span-2 md:col-span-1`}
              type="text"
              name="country"
              placeholder="Country*"
              value={form.country ?? ""}
              onChange={handleChange}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default BillingForm;
